<form [formGroup]="formsControl" class="w-3/4">
  <mat-card>
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center">
      <mat-tab label="Général">
        <mat-divider></mat-divider>
        <mat-card class="m-auto w-3/6">
          <mat-card-header>
            <mat-card-title>
              <h3>Serveur</h3>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content class="flex flex-col">
            <div class="flex">
              <mat-form-field class="large-field">
                <mat-label>Adresse du serveur</mat-label>
                <input matInput placeholder="Ex. sftp://0.0.0.0" id="adresse_serveur"
				  formControlName="adresse_serveur" [readonly]="readonly" autocomplete="off">
                <mat-error *ngIf="adresse_serveur.invalid">{{getErrorMessage("adresse_serveur")}}</mat-error>
              </mat-form-field>
            </div>
            <div class="flex justify-between">
              <mat-form-field>
                <mat-label>Identifiant</mat-label>
                <input matInput placeholder="Renseigner l'identifiant" id="login" formControlName="login"
                  [readonly]="readonly" autocomplete="off">
                <mat-error *ngIf="login.invalid">{{getErrorMessage("login")}}</mat-error>
              </mat-form-field>
              <mat-form-field class="large-field">
                <input matInput placeholder="Mot de passe" id="password" formControlName="password"
                  [readonly]="readonly" autocomplete="new-password" type="{{showPassword ? 'password' : 'text'}}">
                <mat-icon matSuffix (click)="toggleVisibility()" class="icon-click" [ngClass]="{'icon-disabled': getIsDisabled()}">
                  {{showPassword ? 'visibility_off' : 'visibility'}}
                </mat-icon>
                <mat-error *ngIf="password.invalid">{{getErrorMessage("password")}}</mat-error>
              </mat-form-field>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card class="m-auto w-3/6">
          <mat-card-header>
            <mat-card-title>
              <h3>Informations</h3>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content class="flex flex-col">
            <div class="flex justify-between">
              <mat-form-field>
                <mat-label>Nom du DAV</mat-label>
                <input matInput placeholder="Renseigner son nom" formControlName="nom" [readonly]="readonly">
                <mat-error *ngIf="nom.invalid">{{getErrorMessage("nom")}}</mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Site Affectation</mat-label>
                <mat-select placeholder="Sélectionner le site" id="site" [compareWith]="compareSite"
                  formControlName="site" [disabled]="readonly">
                  <mat-option></mat-option>
                  <mat-option *ngFor="let site of sites" [value]="site">
                    {{site.numero}} - {{site.region}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="site.invalid">{{getErrorMessage("site")}}</mat-error>
              </mat-form-field>
            </div>
            <div class="flex">
              <mat-form-field>
                <mat-label>Partenaire</mat-label>
                <input matInput placeholder="Renseigner le partenaire" formControlName="partenaire" [readonly]="readonly">
                <mat-error *ngIf="partenaire.invalid">{{getErrorMessage("partenaire")}}</mat-error>
              </mat-form-field>
            </div>
          </mat-card-content>
        </mat-card>
      </mat-tab>
      <mat-tab label="Comptes Clients" [disabled]="site.value == null">
        <mat-divider></mat-divider>
        <div class="flex flex-col">
          <div class="flex gap-5">
            <mat-form-field>
              <input readonly matInput placeholder="Site"
                [value]="site.value == null ? '' : site.value.numero + ' - ' + site.value.region">
            </mat-form-field>
            <mat-form-field class="large">
              <input matInput placeholder="Numéro Client ou Raison Sociale" [(ngModel)]="clientFilter"
                [ngModelOptions]="{standalone: true}" (keyup)="updateFilter()">
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
          </div>

          <div class="selection flex">
            <div class="tab-container">
              <table mat-table [dataSource]="matInterface">
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let client">
                    <button mat-icon-button (click)="selectClient(client)">
                      <mat-icon>add</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <ng-container matColumnDef="client">
                  <th mat-header-cell *matHeaderCellDef>
                    Client
                  </th>
                  <td mat-cell *matCellDef="let client"> {{client.code_client}}/{{client.code_service}} -
                    {{client.raison_sociale}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="['client','action']"></tr>
                <tr mat-row *matRowDef="let client; columns: ['client','action'];"></tr>
              </table>
            </div>
            <div class="h-full mx-0.5"></div>
            <div class="tab-container">
              <table mat-table [dataSource]="matInterfaceSelected">

                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef> </th>
                  <td mat-cell *matCellDef="let client">
                    <button mat-icon-button (click)="unselectClient(client)">
                      <mat-icon>remove</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <ng-container matColumnDef="site">
                  <th mat-header-cell *matHeaderCellDef> Site </th>
                  <td mat-cell *matCellDef="let client">
                    <ng-container
                      *ngIf="client != undefined && client.site!=undefined">{{client.site.numero}}</ng-container>
                  </td>
                </ng-container>

                <ng-container matColumnDef="client">
                  <th mat-header-cell *matHeaderCellDef> Client </th>
                  <td mat-cell *matCellDef="let client">
                    <ng-container *ngIf="client != undefined">{{client.code_client}}/{{client.code_service}} -
                      {{client.raison_sociale}}</ng-container>
                    <ng-container *ngIf="client === undefined">{{name}}</ng-container>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let client; columns: displayedColumns;"></tr>
              </table>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
    <mat-card-actions>
      <button mat-raised-button color="primary" (click)="submitForm()">Enregistrer</button>
    </mat-card-actions>
  </mat-card>
</form>